import React from 'react'

const Shipment = () => {
    return (
        <div>
            ship ment
        </div>
    )
}

export default Shipment
